import styles from "./taskfilter.module.css";
import { Link } from "react-router-dom";
import { Plus, Search, Calendar, Filter, ArrowRight } from "react-feather";
import DateRangePicker from "rsuite/DateRangePicker";
import { useState } from "react";

const TaskFilter = ({ setFilterData, setAddTaskModalOpen }) => {
  const [filterOpen, setFilterOpen] = useState(false);

  return (
    <div className={`${styles.SearchFilterSec}`}>
      <div className={`${styles.SearchCon}`}>
        <div className={`${styles.SearchConSec}`}>
          <Search />
          <input
            type="text"
            placeholder="Search"
            onChange={(e) =>
              setFilterData((prev) => {
                return { ...prev, searchKey: e.target.value };
              })
            }
          />
        </div>
      </div>
      <div className={`${styles.FilterSec}`}>
        {/* <div className={filterOpen ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setFilterOpen(false)}><ArrowRight /></span>
                </p>
                <div className={`${styles.FilterCard} Filter`}>
                    <div className={`${styles.DashFilterSec} DashFilterSec`}>
                        <DateRangePicker
                            format={"M/d/yy"}
                            placeholder={"Filter by date"}
                            placement={"bottomEnd"}
                            caretAs={Calendar}
                            showOneCalendar
                        />
                    </div>
                </div>
            </div> */}
        <Link
          className={`${styles.FilterBu}`}
          onClick={(e) => setFilterOpen(true)}
        >
          <Filter />
        </Link>
        <Link
          onClick={(e) => setAddTaskModalOpen(true)}
          className={`${styles.AddNoteBu}`}
        >
          <Plus /> <span>Task</span>
        </Link>
      </div>
    </div>
  );
};

export default TaskFilter;
